module.exports = __webpack_public_path__ + "media/img/Landing_Page/tutor-01-00ff537a29aade4d5292c1c0e5d04503.jpg";